import * as React from 'react';
import * as Styles from './ShippingCountry.scss';

import { ICountry, IState, RootState } from '@checkout/state';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { countryChangeRequest, countryStateChangeRequest } from '../../../reducers/checkout';
import { getOptionsData, isOnlyOneCountry } from '../../../utils/address';
import { DropDownField, GroupTitle, Section } from '../../presentational';

import { Field } from 'formik';
import { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormNames } from '../../../utils/formNames';
import messages from './../../../i18n/base-en';

interface IOwnProps { }

interface IConnectedProps {
  countries: ICountry[];
  shippingCountryCode: string | null;
}

interface IConnectetDispatchProps {
  countryChangeRequest: typeof countryChangeRequest;
  countryStateChangeRequest: typeof countryStateChangeRequest;
}

type Props = IOwnProps & IConnectetDispatchProps & IConnectedProps & InjectedIntlProps;

class ShippingCountry extends React.Component<Props, {}> {

  handleCountryChange = (event: ChangeEvent<any>) => {
    const countryCode = event.target.value;
    const formName = FormNames.shippingAddress;

    this.props.countryChangeRequest({ countryCode, formName });
  }

  handleCountryStateChange = (event: ChangeEvent<any>) => {
    const { shippingCountryCode: countryCode } = this.props;
    const stateCode = event.target.value;
    const formName = FormNames.shippingAddress;

    this.props.countryStateChangeRequest({ countryCode, stateCode, formName });
  }

  render() {
    const { countries, shippingCountryCode, intl } = this.props;
    const { formatMessage } = intl;
    const countryOptions = getOptionsData('Country', countries, shippingCountryCode);
    const stateOptions = getOptionsData('State', countries, shippingCountryCode);

    // Do not render country at all if there is only one available
    if (isOnlyOneCountry(countries)) { return null; }

    return (
      <Section blockFor="ShippingCountry">
        <GroupTitle title={formatMessage(messages.shipping_country_group_title)} variant="big" accent={true} />
        <div className={Styles.content}>
          <Field
            id="shippingAddress.country"
            name="shippingAddress.country"
            component={DropDownField}
            placeholder={formatMessage(messages.country_dropdown_placeholder)}
            label={formatMessage(messages.country_label)}
            required={true}
            sizeVariant="medium"
            options={countryOptions}
            valueSelector={(item: ICountry) => item.country}
            type="select"
            onChange={this.handleCountryChange}
          />
          {stateOptions && (
            <Field
              id="shippingAddress.state"
              name="shippingAddress.state"
              component={DropDownField}
              placeholder={formatMessage(messages.state_dropdown_placeholder)}
              label={formatMessage(messages.state_label)}
              required={true}
              sizeVariant="small"
              options={stateOptions}
              valueSelector={(item: IState) => item.state}
              type="select"
              onChange={this.handleCountryStateChange}
            />
          )}
        </div>
      </Section>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      countries: state.checkout.countries,
      shippingCountryCode: state.checkout.fieldsData.shippingAddress && state.checkout.fieldsData.shippingAddress.country,
    }),
    {
      countryChangeRequest,
      countryStateChangeRequest
    },
  )
)(ShippingCountry);
